import React, { createContext, useContext, useState } from 'react';
import { useApplicationContext } from '../v1/Application/context';
import type { Resolution886ReportFilterProviderProps, Parameters, State, Methods, Context } from './types';

const Resolution886ReportFilterContext = createContext<Context>({} as Context);

export const Resolution886ReportFilterProvider = ({ children }: Readonly<Resolution886ReportFilterProviderProps>) => {
	const { organization, company } = useApplicationContext();

	const [parameters, setParameters] = useState<Parameters>({
		organization_id: organization?.id!,
		company_id: company?.id!
	});
	const [offset, setOffset] = useState<number>(1);
	const [limit, setLimit] = useState<number>(5);

	function handleSetParameters(values: Parameters): void {
		setParameters(values);
	}

	function handleSetOffset(offset: number): void {
		setOffset(offset);
	}

	function handleSetLimit(limit: number): void {
		setLimit(limit);
	}

	const states: State = {
		parameters,
		offset,
		limit
	};

	const methods: Methods = {
		handleSetParameters,
		handleSetOffset,
		handleSetLimit
	};

	const context: Context = {
		...states,
		...methods
	};

	return (
		<Resolution886ReportFilterContext.Provider value={context}>
			{children}
		</Resolution886ReportFilterContext.Provider>
	);
};

export const useResolution886ReportFilter = (): Context => {
	const context = useContext(Resolution886ReportFilterContext);

	if (!context) {
		throw new Error('Resolution886ReportFilter context not found!');
	}

	return context;
};
